import React from 'react';
import { Link } from 'react-router-dom';
import wowzaLogo from '../../images/wowza-logo.svg'

const Nav = (props) => {

  return (
    <nav className="navbar navbar-expand-sm navbar-light bg-light pb-3 pb-md-2" id="top-nav">
      
      {/* 1. Thay thế liên kết logo ngoài bằng Link nội bộ (trang chủ) */}
      <Link to="/hop" className="navbar-brand">
        <img className="noll" src={wowzaLogo} alt="Wowza Media Systems" />
      </Link>
      
      <ul className="navbar-nav mr-auto-lg">
        
        {/* 2. Thay thế liên kết Publish ngoài bằng Link nội bộ */}
        <li className="nav-item page">
          <Link to="/publish">
            Publish
          </Link>
          <span></span>
        </li>
        
        {/* 3. Thay thế liên kết Play ngoài bằng Link nội bộ */}
        <li className="nav-item page">
          <Link to="/play">
            Play
          </Link>
          <span></span>
        </li>
        
        {/* === NHÓM 1: buildComponent === 'develop' (Đã giữ nguyên vì dùng Link nội bộ) === */}
        { props.buildComponent === 'develop' && (
          <>
            <li className="nav-item page">
              <Link to="/composite">
                Composite
              </Link>
              <span></span>
            </li>
            <li className="nav-item page">
              <Link to="/meeting">
                Meeting
              </Link>
              <span></span>
            </li>
            <li className="nav-item page">
              <Link to="/hop">
                Hop
              </Link>
              <span></span>
            </li>
          </>
        )}
        
        {/* === NHÓM 2: buildComponent === 'composite' (Thay thế liên kết Meeting ngoài bằng Link nội bộ) === */}
        { props.buildComponent === 'composite' && (
          <>
            <li className="nav-item page active">
              Composite
              <span></span>
            </li>
            <li className="nav-item page">
              <Link to="/meeting"> {/* Đã thay a href="..." bằng Link to="/meeting" */}
                Meeting
              </Link>
              <span></span>
            </li>
          </>
        )}

        {/* === NHÓM 3: buildComponent === 'meeting' (Thay thế liên kết Composite ngoài bằng Link nội bộ) === */}
        { props.buildComponent === 'meeting' && (
          <>
            <li className="nav-item page">
              <Link to="/composite"> {/* Đã thay a href="..." bằng Link to="/composite" */}
                Composite
              </Link>
              <span></span>
            </li>
            <li className="nav-item page active">
                Meeting
              <span></span>
            </li>
          </>
        )}
        
      </ul>
      
     
    </nav>
  );
}

export default Nav;